<style scoped>
.apexcharts-legend.apx-legend-position-bottom.apexcharts-align-left,
.apexcharts-legend.apx-legend-position-top.apexcharts-align-left,
.apexcharts-legend.apx-legend-position-right,
.apexcharts-legend.apx-legend-position-left {
  justify-content: center !important;
  top: 0 !important;
}
</style>
<template>
  <div>
    <v-card color="grey lighten-4" flat height="70px" tile>
      <v-toolbar>
        <v-toolbar-title>Organizational Aggregate Report</v-toolbar-title>
      </v-toolbar>
    </v-card>

    <v-card>
      <v-card-title class="blue white--text text-h5">
        Select the Facility
      </v-card-title>

      <v-row class="pa-4" justify="space-between">
        <v-col cols="5">
          <v-treeview
            :active.sync="active"
            :items="items"
            :load-children="fetchChildren"
            :open.sync="open"
            activatable
            color="warning"
            :loading="loading"
            :search="search"
            item-disabled="locked"
            return-object
            selection-type="independent"
            style="font-size: 1.4em"
          >
            <template v-slot:prepend="{ item }">
              <v-icon v-if="!item.children"> mdi-hospital-building </v-icon>
            </template>
          </v-treeview>
        </v-col>

        <v-divider vertical></v-divider>

        <v-col class="d-flex text-center">
          <v-scroll-y-transition mode="out-in">
            <div
              v-if="!selected"
              class="text-h6 grey--text text--lighten-1 font-weight-light"
              style="align-self: center"
            >
              Select a Facility
            </div>

            <v-card
              v-else
              :key="selected.id"
              class="pt-4 mx-auto"
              raised
              max-width="800"
            >
              <v-card-text>
                <v-icon size="90px" color="green darken-2"> mdi-domain </v-icon>
                <v-row no-gutters>
                  <v-col cols="12">
                    <h2 class="text-h5 mb-2 pa-1">Facility Name-</h2>
                  </v-col>
                </v-row>
                <h3 class="blue--text mb-5" style="font-size: 28px">
                  {{ selected.name }}
                </h3>
                <v-divider darken-4></v-divider>

                <v-row no-gutters>
                  <v-col cols="12">
                    <h2 class="text-h5 mt-5">
                      Total number of employees-
                      <span class="blue--text mb-5">{{ totalEmployees }}</span>
                    </h2>

                    <v-icon size="60px" color="green darken-2">
                      mdi-human-male </v-icon
                    ><span
                      style="color: blue; font-size: 22px; font-weight: bold"
                      >{{ gender[0].male }}</span
                    >
                    &nbsp;
                    <v-icon size="60px" color="green darken-2">
                      mdi-human-female </v-icon
                    ><span
                      style="color: blue; font-size: 22px; font-weight: bold"
                      >{{ gender[0].female }}</span
                    >
                    <h4 class="text-h5 mt-5">
                      Employees data with regard of profession-
                    </h4>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-divider darken-4 class="mb-5"></v-divider>
              <v-row justify="space-around">
                <v-col cols="auto">
                  <v-dialog transition="dialog-top-transition" max-width="1200">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mb-4"
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="showDisabled"
                      >
                        Show the chart</v-btn
                      >
                    </template>
                    <template v-slot:default="dialog">
                      <v-card>
                        <v-toolbar color="secondary" dark
                          >{{ selected.name }}'s&nbsp; Facility data on
                          employees</v-toolbar
                        >
                        <v-card-text>
                          <v-row>
                            <v-col cols="7">
                              <div class="mt-5">
                                <h2>Data based on Job Titles</h2>
                                <div id="chart" class="mt-5">
                                  <apexchart
                                    type="bar"
                                    :options="chartOptions"
                                    :series="result"
                                  ></apexchart>
                                </div>
                              </div>
                            </v-col>
                       
                             <v-col cols="5" class="mt-5">
                                 <h2>Data based on Profession Categories</h2>
                            <v-card class="mt-12 pa-2">
                              
                              
                                <div id="profChart" class="mt-5">
                                  <apexchart
                                    type="donut"
                                    :options="profChartOptions"
                                    :series="profResult"
                                  ></apexchart>
                                </div>
                            
                            </v-card>
                            </v-col>
                          </v-row>
                        </v-card-text>
                        <v-card-actions class="justify-end">
                          <v-btn
                            class="primary"
                            text
                            @click="dialog.value = false"
                            >Close</v-btn
                          >
                        </v-card-actions>
                      </v-card>
                    </template>
                  </v-dialog>
                </v-col>
              </v-row>
            </v-card>
          </v-scroll-y-transition>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>



<script>
import axios from "axios";
import "../../plugins/chart";
const querystring = require("querystring");
export default {
  data: function () {
    return {
      result: [
        {
          name: "Total Number Of Employees",
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          type: "bar",
          height: 10,
        },
        plotOptions: {
          bar: {
            borderRadius: 1,
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: true,
        },
        colors: ["#009639"],

        labels: [],
      },

      profResult: [10, 10, 10, 10, 10],
      profChartOptions: {
        yaxis: {
          tickAmount: 5,
          labels: {
            formatter: function (val) {
              return val.toFixed(0);
            },
          },
        },
        labels: [],
        chart: {
          type: "donut",
        },
        stroke: {
          colors: ["#fff"],
        },
        fill: {
          opacity: 0.8,
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },

      genderData: [],
      dialog: false,
      editDialog: false,
      source: { path: "", data: {} },
      value: { reference: "" },
      loading: false,
      items: [],
      selection: [],
      displayValue: "",
      preset: false,
      active: [],
      open: [],
      totalEmployees: "",
      filledIn: "",
      showDisabled: true,
      treeLookup: {},
      allAllowed: true,
      isFacility: false,
      search: null,
      locationType: [],
      locationStatus: [],
      locationFilter: [],
      locationData: {
        name: "",
        type: "",
        status: "",
      },
      types: [
        {
          id: "2",
          name: "Health Science College",
          locked: false,
          type: "health-science-college",
          children: [],
        },
        {
          id: "3",
          name: "Agencies",
          locked: false,
          type: "agencies",
          children: [],
        },
        {
          id: "4",
          name: "NGO's",
          locked: false,
          type: "ngo",
          children: [],
        },
        {
          id: "5",
          name: "Federal Hospitals",
          locked: false,
          type: "federal-hospitals",
          children: [],
        },
        {
          id: "6",
          name: "Association",
          locked: false,
          type: "association",
          children: [],
        },
        {
          id: "federal-ministry-of-health",
          name: "Regions",
          locked: false,
          type: "regions",
          children: [],
        },
      ].sort((a, b) => {
        return a.name.localeCompare(b.name);
      }),
    };
  },
  created: function () {
    this.setupData();
    this.loadLocationType();
    this.loadLocationStatus();
  },
  watch: {
    slotProps: {
      handler() {
        this.setupData();
      },
      deep: true,
    },
    select: function (val) {
      this.value.reference = val;
    },
    active: function () {
      this.showDisabled = true;
      this.result.data = [];
      this.chartOptions.labels = [];
      if (this.active.length) {
        this.getSelected(this.active[0].name);
        this.select = this.active[0];
        this.displayValue = this.treeLookup[this.select];
        this.locationData.partof = this.select;
      } else {
        this.select = undefined;
        this.displayValue = "";
      }
    },
  },
  methods: {
    setupData: function () {
      this.setupTreeItems();
    },
    setupTreeItems: async function () {
      let treetop = this.initialValue;
      if (this.overrideValue) {
        treetop = this.overrideValue;
      }
      this.loading = true;
      let params = {};
      if (treetop) {
        await this.checkFacility(treetop);
        if (this.isFacility) {
          params = { _id: treetop };
        } else {
          params = { partof: treetop };
        }
      } else {
        params = { "partof:missing": true };
      }
      params.sort = "name";
      let facilityId = this.$store.state.user.facilityId;
      let url = `/fhir/Location?_profile=http://ihris.org/fhir/StructureDefinition/ihris-facility&_sort=name&_id=${facilityId}`;
      this.items = [];
      this.addItems(url, this.items);
    },
    checkFacility: function () {
      let url = "/fhir/Facility?name=name&_sort=name";
      return new Promise((resolve) => {
        fetch(url)
          .then((response) => {
            if (response.ok) {
              response
                .json()
                .then((data) => {
                  if (data.total && data.total == 1) {
                    this.isFacility = true;
                  }

                  resolve();
                })
                .catch((err) => {
                  console.log("failed to check facility for", url, err);
                  resolve();
                });
            } else {
              console.log("failed to check facility for", url, response.status);
              resolve();
            }
          })
          .catch((err) => {
            console.log("failed to check facility for", url, err);
            resolve();
          });
      });
    },
    checkChildren: function (item) {
      let params = { partof: item.id, _summary: "count" };
      let url =
        "/fhir/Location?_sort=name" + "&" + querystring.stringify(params);

      return new Promise((resolve) => {
        fetch(url)
          .then((response) => {
            if (response.ok) {
              response
                .json()
                .then((data) => {
                  if (data.total && data.total > 0) {
                    item.children = [];
                  }
                  resolve();
                })
                .catch((err) => {
                  console.log("failed to check children for", url, err);
                  resolve();
                });
            } else {
              console.log("failed to check children for", url, response.status);
              resolve();
            }
          })
          .catch((err) => {
            console.log("failed to check children for", url, err);
            resolve();
          });
      });
    },
    addItems: function (url, items) {
      // axios.post(`/report/facilityData/`,{url:url,items:ite}).then((response)=>{
      //   console.log(response)
      // })
      fetch(url)
        .then((response) => {
          if (response.ok) {
            response
              .json()
              .then(async (data) => {
                if (data.entry && data.entry.length > 0) {
                  for (let entry of data.entry) {
                    // let locked = this.allAllowed ? false : !entry.resource.meta.profile.includes(this.targetProfile)
                    let locked = false;
                    let item = {
                      id: entry.resource.resourceType + "/" + entry.resource.id,
                      name: entry.resource.name,
                      locked: locked,
                      type: entry.resource.type[0].coding[0].code,
                    };
                    await this.checkChildren(item);
                    this.treeLookup[item.id] = item.name;
                    let facilityId = this.$store.state.user.facilityId;

                    if (
                      facilityId === "federal-ministry-of-health" &&
                      item.id === "Location/federal-ministry-of-health"
                    ) {
                      for (let item of this.types) {
                        await this.checkChildren(item);
                        this.treeLookup[item.id] = item.name;
                      }
                      item.children = this.types;
                    }
                    items.push(item);
                  }
                }
                if (data.link) {
                  let next = data.link.find((link) => link.relation === "next");
                  if (next) {
                    this.addItems(next.url, items);
                  } else {
                    this.loading = false;
                  }
                } else {
                  this.loading = false;
                }
              })
              .catch((err) => {
                console.log("Failed to add items for", url, err);
                this.loading = false;
              });
          } else {
            console.log("Failed to add items for", url, response.status);
            this.loading = false;
          }
        })
        .catch((err) => {
          console.log("Failed to add items for", url, err);
          this.loading = false;
        });
    },
    fetchChildren: function (item) {
      let params = { partof: item.id };
      if (
        item.name === "Agencies" &&
        item.type === "agencies" &&
        item.id === "3"
      ) {
        params = {
          type: "AGN",
          partof: "federal-ministry-of-health",
        };
      }
      if (
        item.name === "Association" &&
        item.type === "association" &&
        item.id === "6"
      ) {
        params = {
          type: "ASSO",
          partof: "federal-ministry-of-health",
        };
      }
      if (item.name === "NGO's" && item.type === "ngo" && item.id === "4") {
        params = {
          type: "NGOs",
          partof: "federal-ministry-of-health",
        };
      }
      if (
        item.name === "Federal Hospitals" &&
        item.type === "federal-hospitals" &&
        item.id === "5"
      ) {
        params = {
          type: "FH",
          partof: "federal-ministry-of-health",
        };
      }
      if (
        item.name === "Regions" &&
        item.type === "regions" &&
        item.id === "federal-ministry-of-health"
      ) {
        params = {
          type: "RHO",
          partof: item.id,
        };
      }
      if (
        item.name === "Health Science College" &&
        item.type === "health-science-college" &&
        item.id === "2"
      ) {
        params = {
          type: "HSC",
          partof: "federal-ministry-of-health",
        };
      }
      let url =
        "/fhir/Location?&_sort=name" + "&" + querystring.stringify(params);

      this.loading = true;

      this.addItems(url, item.children);

      return new Promise((resolve) => {
        let count = 0;
        const checkLoading = () => {
          if (!this.loading || count++ > 100) {
            resolve();
          } else {
            setTimeout(checkLoading, 200);
          }
        };
        checkLoading();
      });
    },

    loadLocationType: function () {
      let url = "/fhir/ValueSet/ihris-jurisdiction-type/$expand";
      fetch(url).then((response) => {
        if (response.ok) {
          response.json().then((data) => {
            this.locationType = data.expansion.contains.filter(
              (l) => !this.locationFilter.includes(l.code.toLowerCase())
            );
          });
        }
      });
    },
    loadLocationStatus: function () {
      let url = "/fhir/ValueSet/location-status/$expand";
      fetch(url).then((response) => {
        if (response.ok) {
          response.json().then((data) => {
            this.locationStatus = data.expansion.contains;
          });
        }
      });
    },

    getSelected(facility) {
      let totalEmployees = 0;
      let employeeId = [];
      // let tempfacilityData;
      if (facility) {
        let url =
          "/fhir/PractitionerRole?employmentStatus=permanent&_content=" +
          facility;
        let employees =
          "/fhir/PractitionerRole?active=true";
     
        //Get the total number of employees from the selected facility
        fetch(employees)
          .then((response) => {
            if (response.ok) {
              response
                .json()
                .then((data) => {
                  if (data.entry) {
                  
                    for (let entry of data.entry) {
                      if (entry.resource &&
                        entry.resource.location[0].reference===this.active[0].id) {
                        employeeId.push(entry.resource.practitioner.reference);
                        console.log(entry.resource)
                        totalEmployees++;
                      }
                    }
                  }

                  let gender = "/fhir/countEmployeesGender/";

                  axios
                    .post(gender, [{ employeeId: employeeId }])
                    .then((response) => {
                      this.genderData = [];

                      this.genderData.push({
                        male: response.data.male,
                        female: response.data.female,
                      });
                    });
                  this.totalEmployees = totalEmployees;
                })
                .catch((err) => {
                  console.log("failed to check children for", url, err);
                });
            } else {
              console.log("failed to check children for", url, response.status);
            }
          })
          .catch((err) => {
            console.log("failed to check children for", url, err);
          });

        //get and calculate the professions of the employees from the seleted facility
        let calculate = "/fhir/getProfessions/";
        let jobs = [];
        let jobsData = [];

        let prof = [];
        let profData = [];

        axios.post(calculate, [{ facility: this.active[0].id }]).then((response) => {
          if (response.data != "empty") {
            Object.entries(response.data.jobs).forEach((entry) => {
              const [key, value] = entry;
              jobs.push(key);
              jobsData.push(value);
            });

            Object.entries(response.data.professionCategories).forEach(
              (entry) => {
                const [key, value] = entry;
                prof.push(key);
                profData.push(value);
              }
            );

            this.showDisabled = false;
          }

          this.chartOptions.labels = jobs;
          this.result[0].data = jobsData;

          this.profChartOptions.labels = prof;
          this.profResult = profData;
        });
      }
    },
  },
  computed: {
    selected: function () {
      return this.active[0];
    },
    gender: function () {
      return this.genderData;
    },
  },
};
</script>
